import styled from '@emotion/styled';
import { SharedStyledChatBubble } from '../SharedChatBubble.styled';
export const StyledChatBubble = styled(SharedStyledChatBubble) `
	padding: 6px 12px;
	white-space: pre-wrap;
	word-break: break-word;
`;
//# sourceMappingURL=ChatBubble.styled.js.map